// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_da-b";
export var colorBlue = "_da-8";
export var colorDot = "_da-0";
export var colorDotLarge = "_da-2";
export var colorDotSmall = "_da-1";
export var colorGreen = "_da-7";
export var colorGrey = "_da-3";
export var colorOrange = "_da-5";
export var colorPink = "_da-a";
export var colorPurple = "_da-9";
export var colorRed = "_da-4";
export var colorYellow = "_da-6";